import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import { Privacy, Terms } from './pages/Legal';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Team from './pages/Team';
import Tasks from './pages/Tasks';
import Time from './pages/Time';
import Accounting from './pages/Accounting';
import Portals from './pages/Portals';
import Billing from './pages/Billing';
import Reports from './pages/Reports';
import SettingsPage from './pages/Settings';
import Templates from './pages/Templates';
import CalendarPage from './pages/Calendar';
import Chat from './pages/Chat';
import Portal from './pages/Portal';
import Access from './pages/Access';
import Financials from './pages/Financials';
import Pay from './pages/Pay';
import PaymentCallback from './pages/PaymentCallback';
import ClientProfile from './pages/ClientProfile';
import SarsPage from './pages/Sars';
import DocumentsPage from './pages/Documents';
import PayrollPage from './pages/Payroll';
import ProspectsPage from './pages/Prospects';
import ProspectDetail from './pages/ProspectDetail';
import Onboard from './pages/Onboard';
import { ChatNotificationsProvider } from './context/ChatNotificationsContext';
import { Toaster } from './components/ui/toaster';

function DashboardRoutes() {
  return (
    <ChatNotificationsProvider>
      <Routes>
        <Route path="" element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientProfile />} />
        <Route path="prospects" element={<ProspectsPage />} />
        <Route path="prospects/:id" element={<ProspectDetail />} />
        <Route path="sars" element={<SarsPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="payroll" element={<PayrollPage />} />
        <Route path="team" element={<Team />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="chat" element={<Chat />} />
        <Route path="time" element={<Time />} />
        <Route path="accounting" element={<Accounting />} />
        <Route path="portals" element={<Portals />} />
        <Route path="billing" element={<Billing />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="templates" element={<Templates />} />
        <Route path="financials" element={<Financials />} />
        <Route path="access" element={<Access />} />
      </Routes>
    </ChatNotificationsProvider>
  );
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const bare = ['/login', '/signup', '/dashboard', '/portal', '/onboard'].some((p) => pathname.startsWith(p));
  return (
    <>
      {!bare && <Navbar />}
      {children}
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App font-sans antialiased">
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard/*" element={<DashboardRoutes />} />
            <Route path="/portal/:token" element={<Portal />} />
            <Route path="/onboard/:token" element={<Onboard />} />
            <Route path="/pay" element={<Pay />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
          </Routes>
        </Shell>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
